import { useQuery } from "@tanstack/react-query";

import { MODULE_NAMES } from "@/constants/modules";
import { LIST_QUERY_KEY } from "@/utils/query";

import { fetchRebillsGroupsListData } from "./rebillsGroupsApi";

export const useRebillsGroups = () =>
  useQuery({
    queryKey: [MODULE_NAMES.REBILLS, LIST_QUERY_KEY],
    queryFn: async () => {
      const { data } = await fetchRebillsGroupsListData();
      return data;
    },
    staleTime: Infinity,
  });
